export default __webpack_public_path__ + "static/media/HazardMon.de24b861.svg";